window.addEventListener("DOMContentLoaded", function() {
    const displayQustionBlock = document.getElementById("displayQuestions");
    // console.log(displayQustionBlock);
    function getQueryParam(param) {
        var urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(param);
    }
    var appid = getQueryParam("appid");
    var userid = getQueryParam("userid");
    if (!appid) {
        var appid = "demo";
        var userid = "demo";
    }
    var hostname = window.location.hostname;
    function setCookie(name, value, days) {
        let cookieString = name + "=" + encodeURIComponent(value) + ";";
        if (days) {
            let expirationDate = new Date();
            expirationDate.setTime(expirationDate.getTime() + days * 86400000); //one day
            cookieString += "expires=" + expirationDate.toUTCString() + ";";
        }
        cookieString += "path=/;";
        cookieString += "domain=" + hostname + ";";
        cookieString += "secure=true;"; // true on production
        cookieString += "samesite=Lax;";
        document.cookie = cookieString;
    }
    // setCookie("appid", appid, 1);
    // setCookie("userid", userid, 1);
    // setCookie("msisdn", userid, 1);
    function getCookieValue(key) {
        const cookies = document.cookie.split(";");
        for(let i = 0; i < cookies.length; i++){
            const cookie = cookies[i].trim();
            if (cookie.startsWith(key + "=")) return cookie.substring(key.length + 1);
        }
        return null;
    }
    //spa_question start
    let score = 0;
    let answeredCount = 0;
    let questions = []; // To store fetched questions
    let correctAnswerCount = 0;
    const quizContainer = document.getElementById("displayQuestions");
    const yourScoreBox = document.getElementById("yourscore");
    const totalPointBox = document.getElementById("totalPoint");
    const questAnsweredBox = document.getElementById("questAnswered");
    const questCorrectAnsweredBox = document.getElementById("questCorrectAnswered");
    let thanksMsg = document.getElementById("thanksMsg");
    // Show the result container
    const resultcontainer = document.getElementById("resultcontainer");
    var resultMsgHtml = `<p class="result-message-line thanks_msg" >\u{915}\u{94B}\u{936}\u{93F}\u{936} \u{92C}\u{922}\u{93C}\u{93F}\u{92F}\u{93E} \u{930}\u{939}\u{940}...</p>
        <p class="result-message-line result_description" >
          \u{905}\u{917}\u{932}\u{940} \u{92C}\u{93E}\u{930} \u{906}\u{92A} \u{92C}\u{947}\u{939}\u{924}\u{930} \u{915}\u{930} \u{938}\u{915}\u{924}\u{947} \u{939}\u{948}\u{902}.
        </p>
        <p class="result-message-line result_description"  >
          \u{905}\u{917}\u{932}\u{947} \u{938}\u{92A}\u{94D}\u{924}\u{93E}\u{939} \u{92E}\u{93F}\u{932}\u{947}\u{917}\u{940} \u{928}\u{908} \u{915}\u{94D}\u{935}\u{93F}\u{91C}\u{93C}.
        </p>
        <p class="hasTag">
          #NDTVQuizGame \u{915}\u{94B} \u{92B}\u{93C}\u{949}\u{932}\u{94B} \u{915}\u{930}\u{947}\u{902} \u{914}\u{930} \u{915}\u{94B}\u{908} \u{92D}\u{940} \u{92A}\u{932} \u{928} \u{91A}\u{942}\u{915}\u{947}\u{902}\u{964}
        </p>`;
    let resultMsgBox = document.getElementById("resultMsg");
    resultMsgBox.innerHTML = resultMsgHtml;
    // questAnswered
    let totalQuestion = "";
    // document.getElementById("spa_question").innerHTML = "Loading...";
    var startDate = getQueryParam("startDate");
    var endDate = getQueryParam("endDate");
    var category = getQueryParam("category");
    if (startDate !== null && endDate !== null && category !== null) var questionUrl = "https://mtech.graphity.in/cms/api/quiz/ndtv?category=" + category + "&lang=hindi&size=7&startDate=" + startDate + "&endDate=" + endDate;
    else if (startDate !== null && endDate !== null) var questionUrl = "https://mtech.graphity.in/cms/api/quiz/ndtv?category=quiz&lang=hindi&size=7&startDate=" + startDate + "&endDate=" + endDate;
    else // var questionUrl = "./data.json";
    var questionUrl = "https://mtech.graphity.in/cms/api/quiz/ndtv?category=quiz&lang=hindi&size=7";
    function fetchQuestions() {
        fetch(questionUrl).then((response)=>{
            return response.json();
        }).then((data)=>{
            questions = data;
            totalQuestion = questions.length;
            // console.log(questions);
            let shuffled = questions.map((value)=>({
                    value,
                    sort: Math.random()
                })).sort((a, b)=>a.sort - b.sort).map(({ value })=>value);
            // console.log(shuffled);
            questions = shuffled;
            // document.getElementById("spa_ques_count").innerHTML = totalQuestion;
            // document.getElementById("totalqustion_probar").innerHTML = totalQuestion;
            displayQuestions(questions);
        });
    }
    function displayQuestions(questions) {
        quizContainer.innerHTML = ""; // Clear the container
        questions.forEach((question, index)=>{
            let imagePath = question.image;
            let readMoreLink = question.url;
            let descriptionText = question.toolTip;
            if (imagePath === null || imagePath === undefined || imagePath === "") imagePath = "./src/img/img1.png";
            if (readMoreLink === null || readMoreLink === undefined || readMoreLink === "") readMoreLink = "#";
            if (descriptionText === null || descriptionText === undefined || descriptionText === "") descriptionText = "Lorem Ipsum is simply dummy text of the printing and typesetting industry. ";
            let questionHtml = `
      <div class="quiz-question" id="question-${index + 1}">
        <span class="question-number">Q ${index + 1}/${questions.length}</span>
        <h2 class="question">${question.question}</h2>
        <div class="options">`;
            if (question.optionA) questionHtml += `<button class="option" onclick="checkAnswer(this, '${question.correctAnswer === "A"}', ${index + 1})">
              ${question.optionA}
            </button>`;
            if (question.optionB) questionHtml += ` <button class="option" onclick="checkAnswer(this, '${question.correctAnswer === "B"}', ${index + 1})">
            ${question.optionB}
          </button>`;
            if (question.optionC) questionHtml += ` <button class="option" onclick="checkAnswer(this, '${question.correctAnswer === "C"}', ${index + 1})">
            ${question.optionC}
          </button>`;
            if (question.optionD) questionHtml += `<button class="option" onclick="checkAnswer(this, '${question.correctAnswer === "D"}', ${index + 1})">
           ${question.optionD}
          </button>`;
            questionHtml += `  </div>
        
      </div>
      <hr class="separator" />
      `;
            quizContainer.insertAdjacentHTML("beforeend", questionHtml);
        });
    }
    function checkAnswer(button, isCorrect, questionNumber) {
        // Disable all buttons in the same question
        const options = button.parentElement.querySelectorAll("button");
        options.forEach((option)=>{
            option.disabled = true;
        });
        // Add your answer checking logic here
        if (isCorrect === "true") {
            button.classList.add("correct");
            score += 5; // Add 5 points for the correct answer
            correctAnswerCount++;
        } else button.classList.add("incorrect");
        yourScoreBox.innerHTML = score;
        totalPointBox.innerHTML = score;
        // Update the score and answered count
        answeredCount++;
        questAnsweredBox.innerText = answeredCount;
        // Show the info container
        // const infoContainer = button
        //   .closest(".quiz-question")
        //   .querySelector(".info-container");
        // infoContainer.style.display = "block";
        if (questions.length == answeredCount) {
            resultcontainer.style.display = "block";
            questCorrectAnsweredBox.innerHTML = correctAnswerCount;
        }
        if (score >= 0 && score <= 10) {
            var resultMsgHtml = `<p class="result-message-line result_description" >
          \u{90F}\u{915} \u{92C}\u{93E}\u{930} \u{92B}\u{93F}\u{930} \u{92A}\u{94D}\u{930}\u{92F}\u{93E}\u{938} \u{915}\u{930}\u{947}\u{902}...
        </p>
        <p class="result-message-line result_description" >
          \u{92F}\u{93E} \u{916}\u{947}\u{932}\u{947}\u{902} \u{905}\u{917}\u{932}\u{940} \u{915}\u{94D}\u{935}\u{93F}\u{91C}\u{93C}...
        </p>
        <p class="hasTag">
          #NDTVQuizGame \u{915}\u{94B} \u{92B}\u{93C}\u{949}\u{932}\u{94B} \u{915}\u{930}\u{947}\u{902}, \u{914}\u{930} \u{916}\u{941}\u{926} \u{915}\u{94B} \u{938}\u{93E}\u{92C}\u{93F}\u{924} \u{915}\u{930}\u{928}\u{947} \u{915}\u{93E} \u{915}\u{94B}\u{908} \u{92E}\u{94C}\u{915}\u{93E} \u{928} \u{91A}\u{942}\u{915}\u{947}\u{902}...
        </p>`;
            resultMsgBox.innerHTML = resultMsgHtml;
            thanksMsg.innerHTML = "\u0939\u093F\u0928\u094D\u0926\u0940 \u092D\u093E\u0937\u093E \u092E\u0947\u0902 \u092A\u0930\u093F\u0936\u094D\u0930\u092E, \u092F\u093E\u0928\u0940 \u092E\u0947\u0939\u0928\u0924 \u0915\u0940 \u0906\u0935\u0936\u094D\u092F\u0915\u0924\u093E, \u092F\u093E\u0928\u0940 \u091C\u093C\u0930\u0942\u0930\u0924 \u0939\u0948...";
        } else if (score == totalQuestion * 5) {
            var resultMsgHtml = `<p class="result-message-line result_description" >
      \u{905}\u{92C} \u{916}\u{947}\u{932}\u{947}\u{902} \u{905}\u{917}\u{932}\u{940} \u{915}\u{94D}\u{935}\u{93F}\u{91C}\u{93C}...
    </p>
    
    <p class="hasTag">
       #NDTVQuizGame \u{915}\u{94B} \u{92B}\u{93C}\u{949}\u{932}\u{94B} \u{915}\u{930}\u{947}\u{902}, \u{914}\u{930} \u{916}\u{941}\u{926} \u{915}\u{94B} \u{938}\u{93E}\u{92C}\u{93F}\u{924} \u{915}\u{930}\u{928}\u{947} \u{915}\u{93E} \u{915}\u{94B}\u{908} \u{92E}\u{94C}\u{915}\u{93E} \u{928} \u{91A}\u{942}\u{915}\u{947}\u{902}...
    </p>`;
            resultMsgBox.innerHTML = resultMsgHtml;
            thanksMsg.innerHTML = "\u092C\u0938, \u0906\u092A \u0939\u0940 \u0939\u0948\u0902 \u0939\u092E\u093E\u0930\u0947 \u092D\u093E\u0937\u093E \u0935\u093F\u0926\u094D\u0935\u093E\u0928...";
        } else if (score >= 15 && score <= 30) {
            var resultMsgHtml = `<p class="result-message-line result_description"   >
      \u{90F}\u{915} \u{92C}\u{93E}\u{930} \u{92B}\u{93F}\u{930} \u{92A}\u{94D}\u{930}\u{92F}\u{93E}\u{938} \u{915}\u{930}\u{947}\u{902}...
    </p>
    <p class="result-message-line result_description" >
       \u{92F}\u{93E} \u{916}\u{947}\u{932}\u{947}\u{902} \u{905}\u{917}\u{932}\u{940} \u{915}\u{94D}\u{935}\u{93F}\u{91C}\u{93C}...
    </p>
    <p class="hasTag">
      #NDTVQuizGame \u{915}\u{94B} \u{92B}\u{93C}\u{949}\u{932}\u{94B} \u{915}\u{930}\u{947}\u{902}, \u{914}\u{930} \u{916}\u{941}\u{926} \u{915}\u{94B} \u{938}\u{93E}\u{92C}\u{93F}\u{924} \u{915}\u{930}\u{928}\u{947} \u{915}\u{93E} \u{915}\u{94B}\u{908} \u{92E}\u{94C}\u{915}\u{93E} \u{928} \u{91A}\u{942}\u{915}\u{947}\u{902}...
    </p>`;
            resultMsgBox.innerHTML = resultMsgHtml;
            thanksMsg.innerHTML = "\u092C\u0938, \u0925\u094B\u0921\u093C\u0940-\u0938\u0940 \u0915\u0938\u0930 \u0930\u0939 \u0917\u0908... \u092D\u093E\u0937\u093E \u0935\u093F\u0926\u094D\u0935\u093E\u0928 \u0915\u0939\u0932\u093E\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0905\u092D\u0940 \u0915\u0941\u091B \u092A\u094D\u0930\u092F\u093E\u0938 \u0915\u0930\u0928\u093E \u0939\u094B\u0917\u093E...";
        }
    }
    window.checkAnswer = checkAnswer;
    function restartGame() {
        // Reset score and answered count
        score = 0;
        answeredCount = 0;
        correctAnswerCount = 0;
        // Update the display
        yourScoreBox.innerHTML = score;
        totalPointBox.innerHTML = score;
        questAnsweredBox.innerText = answeredCount;
        var resultMsgHtml = `<p class="result-message-line thanks_msg" >\u{915}\u{94B}\u{936}\u{93F}\u{936} \u{92C}\u{922}\u{93C}\u{93F}\u{92F}\u{93E} \u{930}\u{939}\u{940}...</p>
  <p class="result-message-line  result_description">
    \u{905}\u{917}\u{932}\u{940} \u{92C}\u{93E}\u{930} \u{906}\u{92A} \u{92C}\u{947}\u{939}\u{924}\u{930} \u{915}\u{930} \u{938}\u{915}\u{924}\u{947} \u{939}\u{948}\u{902}.
  </p>
  <p class="result-message-line result_description">
    \u{905}\u{917}\u{932}\u{947} \u{938}\u{92A}\u{94D}\u{924}\u{93E}\u{939} \u{92E}\u{93F}\u{932}\u{947}\u{917}\u{940} \u{928}\u{908} \u{915}\u{94D}\u{935}\u{93F}\u{91C}\u{93C}.
  </p>
  <p class="hasTag">
    #NDTVQuizGame \u{915}\u{94B} \u{92B}\u{93C}\u{949}\u{932}\u{94B} \u{915}\u{930}\u{947}\u{902} \u{914}\u{930} \u{915}\u{94B}\u{908} \u{92D}\u{940} \u{92A}\u{932} \u{928} \u{91A}\u{942}\u{915}\u{947}\u{902}\u{964}
  </p>`;
        resultMsgBox.innerHTML = resultMsgHtml;
        let shuffled = questions.map((value)=>({
                value,
                sort: Math.random()
            })).sort((a, b)=>a.sort - b.sort).map(({ value })=>value);
        // console.log(shuffled);
        questions = shuffled;
        // Redisplay the questions
        displayQuestions(questions);
        resultcontainer.style.display = "none";
    }
    window.restartGame = restartGame;
    fetchQuestions();
}, false);

//# sourceMappingURL=index.cc288c4d.js.map
